module.exports = __webpack_public_path__ + "img/sfdw_cn.824e71ba.png";